// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9c172ee0","455":"9648846f","977":"07fc99c4"}[chunkId] + ".chunk.js";
};